import React from 'react';
import PropTypes from 'prop-types';
import {
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment-timezone";

const defaultClasses = StyleSheet.create({
    cellWidth: {
        width: "30%",
        margin: "auto"
    }
});

const RefuelTable = props => {
    const { classes = defaultClasses, refuels, title } = props;

    const drawTable = data => {
        let i = 0;
        return data.map(row => {
            return (
                <View
                    key={i++}
                    style={classes.row}
                    break={i%20 === 0}
                >
                    <View style={[classes.cell, defaultClasses.cellWidth]}>
                        <Text style={classes.textPrimary}>
                            {moment.unix(row.data).format("DD/MM/YYYY \n HH:mm:ss")}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth]} wrap>
                        <Text style={classes.textPrimary}>
                            {row.litry}&nbsp;l
                        </Text>
                    </View>
                </View>
            );
        });
    };

    return (
        <Page
            style={classes.page}
            orientation="portrait"
        >
            <View style={classes.title}>
                <Text style={classes.textHeader}>
                    {title}
                </Text>
            </View>
            <View style={classes.table}>
                <View style={[classes.row, classes.headerCell]}>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Data:
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Ilość:
                        </Text>
                    </View>
                </View>
            <View>
                {drawTable(refuels)}
            </View>
            </View>
        </Page>
    );
};

RefuelTable.propTypes = {
    classes: PropTypes.object,
    refuels: PropTypes.array,
    title: PropTypes.string
};

export default RefuelTable;
